/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { userRemoveMember } from '../../axios/userRemoveMember'
import type {
	UserRemoveMemberError,
	UserRemoveMemberPathParams,
	UserRemoveMemberResponse,
} from '../../types/UserRemoveMember'

export const userRemoveMemberMutationKey = () => [{ url: '/users/:user' }] as const

export type UserRemoveMemberMutationKey = ReturnType<typeof userRemoveMemberMutationKey>

export type UserRemoveMemberVariables = {
	user: UserRemoveMemberPathParams['user']
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::removeMember */
export function useUserRemoveMember<TContext = unknown>(
	options?: UseMutationOptions<
		UserRemoveMemberResponse,
		AxiosError<UserRemoveMemberError>,
		UserRemoveMemberVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: userRemoveMemberMutationKey(),
		mutationFn: ({ user }: UserRemoveMemberVariables) => userRemoveMember(user, config).then(res => res.data),
		...options,
	})
}
